export default {
    Add_Variation(state, payload){
        state.addvariation = payload.value;
    },
}